import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UsersIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M13 14H5c-2.8 0-5 2.2-5 5v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-2.8-2.2-5-5-5zM9 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM20.3 14.1c-.5-.1-1.1.2-1.2.7-.1.5.2 1.1.7 1.2 1.4.4 2.3 1.6 2.3 2.9v2c0 .6.4 1 1 1s1-.4 1-1v-2c-.1-2.2-1.6-4.2-3.8-4.8zM16.2 2.1c-.5-.1-1 .2-1.2.8-.1.5.2 1.1.7 1.2 1.6.4 2.5 2 2.2 3.7-.3 1.1-1.2 1.9-2.2 2.2-.5.2-.8.7-.7 1.2.1.4.5.7 1 .7h.3c1.7-.5 3.1-1.9 3.6-3.6.6-2.8-1-5.5-3.7-6.2z"
                    })
                })
            })
        ]
    });
};
UsersIcon.isCarinaIcon = true;
export default UsersIcon;
